import { createFileRoute, Link } from "@tanstack/react-router";
import { AppHeader } from "../components/AppHeader";
import { t } from "../i18n/en";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/about")({
  head: () => pageHead("What Is Human Design?", { canonicalPath: "/about" }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <main className="relative mx-auto w-full max-w-4xl px-5 py-4 sm:px-8 sm:py-6">
      <AppHeader />
      <section className="mx-auto w-full max-w-[28rem] py-4 sm:py-6">
        <h1 className="font-display text-[clamp(2rem,4vw,3rem)] font-bold lowercase leading-none text-black">
          {t("ui.copy_what_is_human_design_77906202")}
        </h1>
        <p className="mt-3 text-[13px] leading-[1.55] text-black/70 sm:text-[14px]">
          {t("ui.copy_human_design_weaves_togethers_aspect_da0d213b")}
        </p>
        <h2 className="mt-6 border-t border-black/20 pt-5 font-display text-[clamp(2rem,4vw,3rem)] font-bold lowercase leading-none text-black">
          {t("ui.copy_origin_story_48d43b27")}
        </h2>
        <p className="mt-3 text-[13px] leading-[1.55] text-black/70 sm:text-[14px]">
          {t("ui.copy_human_design_has_a_rather_unusual_or_97e60d4b")}
        </p>
        <p className="mt-3 text-[13px] leading-[1.55] text-black/70 sm:text-[14px]">
          {t("ui.copy_whether_you_see_it_as_a_mystical_tra_346b96d2")}
        </p>
        <p className="mt-4">
          <Link
            to="/"
            className="inline-flex rounded-full bg-[#95A789] px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-black transition hover:bg-[#859877]"
          >
            {t("common.backHome")}
          </Link>
        </p>
      </section>
    </main>
  );
}
